<template>
  <div style="height: 100%">
    <div class="grid-view" style="height: 100%">
      <div class="main-content">
        <div class="app-main-inner-row" style="height: 100%;">
          <!--  业务树  -->
          <div class="section grid-wrapper" style="width:15%;min-width:190px;border:1px solid #ccc;display: flex;cursor: pointer">
            <cargo-ag-grid
              :show-side-bar="false"
              :grid-options="lobTree.gridOptions"
              :column-defs="lobTree.columnDefs"
              :row-data="lobTree.rowData"
              style="width:100%;height:100%;min-height: 500px;"
            />
          </div>
          <div class="section grid-wrapper" style="min-width:85%;border:1px solid #ccc;display: flex;">
            <tenant-instruction
              ref="tenantInstruction"
              :data-type="lobTree.selectRow.dataType"
              :instruction-lob="lobTree.selectRow.dataType === INSTRUCTION_TREE_DATE_TYPE_LOB.code ? lobTree.selectRow.code : lobTree.selectRow.parentCode"
              :instruction-type="lobTree.selectRow.dataType === INSTRUCTION_TREE_DATE_TYPE_LOB.code ? '' : lobTree.selectRow.code"
              :platform-instructions="platformInstructions"
              :mail-templates="mailTemplates"
              :templates="templates"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ColumnUtils from '@/utils/ColumnUtils'
import {
  EMAIL_PARSING_TYPE,
  FBA_IE_LOBS,
  INSTRUCTION_SOURCES,
  INSTRUCTION_TREE_DATE_TYPE_INSTRUCTION_TYPE,
  INSTRUCTION_TREE_DATE_TYPE_LOB,
  INSTRUCTION_TYPES, PUSH_LINK_LIST, SOP_CONFIG_LOBS
} from '@/class/cargo/model/parameters/SystemConstants'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getAllTenant } from '@/api/auth'
import TenantInstruction from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantInstruction'
import lodash from 'lodash'
import {
  queryAllPlatformInstructionByTenant,
  queryAllTenantInstruction,
  querySpecificBusinessRuleByTenant
} from '@/api/sysManage/baseConfig/instruction'
import * as userApi from '@/api/user'
import { getMailTemplateByParams } from '@/api/user'
import { cache, cacheName } from '@/utils/cacheManager'
import { getDocumentTypeListFunc } from '@/api/documentType'
import { getTemplateList } from '@/api/sysManage/baseConfig/template'

export default {
  name: 'TenantInstructionWrap',
  components: {
    CargoAdvanceSelect,
    TenantInstruction
  },
  data() {
    return {
      INSTRUCTION_TYPES, INSTRUCTION_SOURCES, INSTRUCTION_TREE_DATE_TYPE_LOB,
      total: 0,
      isZh: this.$store.getters.language === 'zh',
      EMAIL_PARSING_TYPE,
      selectTypeNames: TYPE_NAMES,
      loading: false,
      lobTree: {
        columnDefs: [],
        rowData: [],
        selectRow: {},
        gridOptions: {
          rowSelection: 'single',
          groupDefaultExpanded: 1,
          suppressRowClickSelection: false,
          treeData: true,
          getDataPath: (data) => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('CargoMsg.Cargo_Name'),
            width: 280,
            cellStyle: (params) => {
              if (params.data.dataType === INSTRUCTION_TREE_DATE_TYPE_LOB.code) {
                return { color: '' }
              }
              return { color: 'gray' }
            },
            cellRendererParams: {
              // suppressCount: true,
              suppressDoubleClickExpand: true,
              innerRenderer: (params) => {
                if (params.data.dataType === INSTRUCTION_TREE_DATE_TYPE_LOB.code) {
                  return ColumnUtils.fbaIeJobLabelFunc(params.data.code)
                } else {
                  return ColumnUtils.instructionTypeLabelFunc(params.data.code)
                }
              },
              checkbox: (params) => {
                return false
              }
            }
          },
          onRowClicked: this.onLobTreeClick
        }
      },
      selectedRow: null,
      tenants: [],
      platformInstructions: [], // 平台指令
      mailTemplates: [], // 邮件配置模板
      templates: [], // 打印模板
      officeMap: new Map(), // 分公司
      documentTypeMap: new Map(), // 文件类型
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          filter: true
        }
      },
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      settingDialog: {
        isEdit: false,
        title: this.$t('CargoMsg.Cargo_OperationInstructions'),
        visible: false,
        form: {
          uuid: '',
          version: 0,
          instructionName: '',
          lob: '',
          ruleCode: '',
          codeParamDescription: '',
          isPlatform: true,
          remark: ''
        }
      },
      pushList: PUSH_LINK_LIST
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    pushListMap: function() {
      const obj = {}
      this.pushList.map((item) => {
        obj[item.id] = item.name
      })
      return obj
    }
  },
  async created() {
    await cache.load(cacheName.USER, cacheName.OFFICE_LIST)
    for (const item of cache.officeList) {
      this.officeMap.set(item.officeId, item.chineseName)
    }
    getAllTenant().then(res => {
      this.tenants = res.data
    })
  },
  activated() {
    this.initPlatformInstructionAndMailTemplate()
  },
  mounted() {
    this.fetchTreeData()
    // 默认选中第一行
    this.lobTree.gridOptions.api.setFocusedCell(0, this.lobTree.gridOptions.api.columnController.getAllDisplayedColumns()[0])
    // 默认打开【海运出口】
    this.lobTree.selectRow = this.lobTree.rowData[0]
  },
  methods: {
    initPlatformInstructionAndMailTemplate() {
      // 查询 平台操作指令
      queryAllPlatformInstructionByTenant({}).then(res => {
        this.platformInstructions = res.data
      })
      // 查询 所有邮件模板
      getMailTemplateByParams({}).then(res => {
        this.mailTemplates = res.data
        if (this.mailTemplates && this.mailTemplates.length > 0) {
          this.mailTemplates.forEach((item) => {
            item.pushLinkName = this.pushListMap[item.pushLink]
            // 设置对象中文名称
            if (item.multipleAccountId) {
              const accountIds = (item.multipleAccountId).split(',')
              item.multipleAccountIdName = ''
              for (const accountId of accountIds) {
                item.multipleAccountIdName += (item.multipleAccountIdName ? ',' : '') + ColumnUtils.emailAccountLabelFunc(Number(accountId))
              }
            }
            if (item.multipleOfficeId) {
              const officeIds = (item.multipleOfficeId).split(',')
              item.multipleOfficeIdName = ''
              for (const officeId of officeIds) {
                item.multipleOfficeIdName += (item.multipleOfficeIdName ? ',' : '') + ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(officeId), 'code')
              }
            }
          })
        }
      })
      // 查询 所有打印模板
      getDocumentTypeListFunc({}).then(res => {
        if (res.data) {
          for (const item of res.data) {
            this.documentTypeMap.set(item.uuid, item.name)
          }
        }
        getTemplateList({}).then(res => {
          if (res.data) {
            const relatedTemplateMap = new Map()
            for (const item of res.data) {
              if (item.engine !== 0) {
                relatedTemplateMap.set(item.uuid, item.name)
              }
            }
            res.data.forEach(p => {
              if (p.engine !== 0 && p.coverTemplateUuid) {
                p.coverTemplateUuidStr = relatedTemplateMap.get(p.coverTemplateUuid)
              } else {
                p.coverTemplateUuidStr = ''
              }
              if (p.documentTypeUuid) {
                p.documentTypeUuidStr = this.documentTypeMap.get(p.documentTypeUuid)
              } else {
                p.documentTypeUuidStr = ''
              }
              switch (p.engine) {
                case 0:
                  p.engineStr = 'JasperReport'
                  break
                case 1:
                  p.engineStr = 'StiReport'
                  break
                case 2:
                  p.engineStr = 'V3'
                  break
                default:
                  p.engineStr = ''
              }
              p.officeIdStr = this.officeMap.get(p.officeId)
              p.templateUsageStr = p.templateUsage > 0 ? this.$t('SystemMaintenance.Email') : this.$t('SystemMaintenance.Printing')
            })
            this.templates = res.data
          }
        })
      })
    },
    fetchTreeData() {
      this.lobTree.rowData = []
      for (const lob of SOP_CONFIG_LOBS.keys()) {
        lob.path = lob.code
        lob.dataType = INSTRUCTION_TREE_DATE_TYPE_LOB.code
        this.lobTree.rowData.push(lob)
        // 二期 需要下面的代码，先注释
        // const instructionTypes = lodash.cloneDeep(INSTRUCTION_TYPES)
        // for (const instructionType of instructionTypes) {
        //   instructionType.path = lob.code + ',' + instructionType.code
        //   instructionType.parentCode = lob.code
        //   instructionType.dataType = INSTRUCTION_TREE_DATE_TYPE_INSTRUCTION_TYPE.code
        //   this.lobTree.rowData.push(instructionType)
        // }
      }
    },
    onLobTreeClick(event) {
      this.lobTree.selectRow = event.node.data
      this.$refs.tenantInstruction.filter.chineseName = ''
      this.$nextTick(() => {
        this.$refs.tenantInstruction.queryHandler()
      })
    }
  }
}
</script>

<style lang="scss" scoped>

#app /deep/ .el-form-item__label {
  text-align: right;
}

.lable-blue ::v-deep {
  .el-form-item__label {
    color: #1F75D5 !important;
  }
}

</style>
